/* global sr */

import Vue from 'vue';
import $ from 'jquery';

// Initialize siteData variable on window
window.siteData = window.siteData || {};

// Add site-wide data here:
const siteData = Object.assign(
	window.siteData,
	{
		qdIsNavOpen: false,
		qdScrollPosition: 0,
		qdHasStickyNav: false,
		qdShowStickyNav: false,
		qdHideElements: false,
	}
);

export default new Vue({
	el: '#root',
	data: siteData,
	components: {
	},
	methods: {
		updateData(name, value) {
			if (process.env.NODE_ENV !== 'production') {
				console.log(name, value);
			}
			siteData[name] = value;
		},
		setActive() {
			siteData.qdIsActive = !siteData.qdIsActive;
		},
		toggleNav() {
			siteData.qdIsNavOpen = !siteData.qdIsNavOpen;
		},
		onScroll() {
			const currentScrollPosition = window.scrollY;
			siteData.qdHasStickyNav = currentScrollPosition > 500;
			siteData.qdShowStickyNav = currentScrollPosition < siteData.qdScrollPosition && currentScrollPosition !== 0 && !siteData.qdPopup;
			siteData.qdScrollPosition = currentScrollPosition;
		},
	},
	created() {
		window.addEventListener('scroll', this.onScroll);
	},
	mounted() {
		sr.reveal('.js-scroll-reveal', {
			easing: 'cubic-bezier( .395, .325, .365, .995 )',
			viewFactor: 0.6,
		});
		sr.reveal('.js-scroll-reveal--static', {
			distance: 0,
			scale: 0,
		});
		sr.reveal('.js-scroll-reveal--right', {
			origin: 'right',
		});
		sr.reveal('.js-scroll-reveal--delay', {
			delay: 500,
		});
		sr.reveal('.js-scroll-reveal--delay-250', {
			delay: 250,
		});
		sr.reveal('.js-scroll-reveal--delay-1s', {
			delay: 1000,
		});
		sr.reveal('.js-scroll-reveal--delay-1-5s', {
			delay: 1500,
		});
		sr.reveal('.js-scroll-reveal--duration-1s', {
			duration: 1000,
		});
		sr.reveal('.js-scroll-reveal--sequence', 20);
		sr.reveal('.js-scroll-reveal--sequence-50', 50);
		sr.reveal('.js-scroll-reveal--sequence-50-2', 50);
		sr.reveal('.js-scroll-reveal--sequence-50-3', 50);
	},
	destroyed() {
		window.removeEventListener('scroll', this.onScroll);
	},
});




// WEBPACK FOOTER //
// ./assets/_js/components/root.js